import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { handleSession } from "../../../api/apiSessionHandle";
import { PaginationControls } from "../../../components/pagination";
import showToast from "../../../services/toastifyservices";
import { FaEdit } from "react-icons/fa";
import {
  getaxiosadminRequestWithToken,
  postaxiosadminRequestWithToken,
  putaxiosadminRequestWithToken,
} from "../../../api/api";
import { useNavigate } from "react-router-dom";
import CommonSpinner from "../../../services/commonSpinner";
import Select from "react-select";

const ManageAddress = () => {
  const navigate = useNavigate();
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [addressData, setAddressDta] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState({});
  const [showAddAddressModal, setShowAddAddressModal] = useState(false);
  const [talkehrAddress, setTalkehrAddress] = useState([]);

  //! Pagination state
  const [currentPage, setCurrentPage] = useState();
  const [rowsPerPage, setRowsPerPage] = useState();
  const [totalPages, setTotalPages] = useState();

  const [addForm, setAddForm] = useState({
    address: "",
    city: "",
    state: "",
    status: "",
    latitude: "",
    longitude: "",
  });
  const [updateForm, setUpdateForm] = useState({
    address: "",
    city: "",
    state: "",
    status: "",
    latitude: "",
    longitude: "",
  });
  const [errors, setErrors] = useState({});

  const fetchAddresses = async (page) => {
    const payload = { page: page };
    setLoading(true);
    try {
      const response = await getaxiosadminRequestWithToken(
        `common_api/fetch-addresses`,
        payload
      );
      if (response) {
        setAddressDta(response.data?.addresses?.data || []);
        setRowsPerPage(response.data?.addresses.per_page);
        setCurrentPage(response.data?.addresses.current_page);
        setTotalPages(
          Math.ceil(
            response.data?.addresses.total / response.data?.addresses.per_page
          )
        );
      }
    } catch (error) {
      setAddressDta([]);
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchTalkehrAddress = async () => {
    try {
      const response = await getaxiosadminRequestWithToken(
        `/admin_api/fetch-talkehr-locations`
      );
      if (response) {
        const addressOptions = response.data.map((item) => {
          return { label: item.name, value: item.id };
        });
        setTalkehrAddress(addressOptions || []);
      }
    } catch (error) {
      setTalkehrAddress([]);
      handleError(error);
    }
  };

  const handleError = (error) => {
    showToast(
      "error",
      error.response?.data?.message || "Something went wrong."
    );
    handleSession(error.response?.data, navigate);
  };
  const handleSearch = () => {
    fetchAddresses();
  };
  useEffect(() => {
    fetchAddresses();
    fetchTalkehrAddress();
  }, []);

  const handleAddressChange = (e) => {
    const { name, value } = e.target;
    setUpdateForm({ ...updateForm, [name]: value });
    if (value.trim() !== "") {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAddForm((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (value.trim() !== "") {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };

  const validateForm = (form, isAddForm = false) => {
    const newErrors = {};

    if (!form.address?.trim()) newErrors.address = "Address is required.";
    if (!form.city?.trim()) newErrors.city = "City is required.";
    if (!form.state?.trim()) newErrors.state = "State is required.";
    // if (!isAddForm && !form.status?.trim()) {
    //   newErrors.status = "Status is required.";
    // }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleClose = () => {
    setAddForm({
      address: "",
      city: "",
      state: "",
      status: "",
      latitude: "",
      longitude: "",
    });
    setErrors({});
    setShowAddAddressModal(false);
  };
  const handleAddAddress = async () => {
    if (!validateForm(addForm, true)) return;
    setFormLoading(true);
    try {
      const response = await postaxiosadminRequestWithToken(
        `admin_api/addresses`,
        addForm
      );
      if (response) {
        setShowAddAddressModal(false);
        setAddForm({ address: "", city: "", state: "", status: "" });
        setErrors({});
        fetchAddresses(); // Refresh list
      }
    } catch (error) {
      handleError(error);
    } finally {
      setFormLoading(false);
    }
  };

  const handleUpdateAddress = async () => {
    if (!validateForm(updateForm, false)) return;

    setFormLoading(true);
    try {
      const response = await putaxiosadminRequestWithToken(
        `admin_api/addresses/${selectedAddress.id}`,
        updateForm
      );
      if (response) {
        setShowAddressModal(false);
        setUpdateForm({ address: "", city: "", state: "", status: "" });
        setErrors({});
        fetchAddresses(); // Refresh list
      }
    } catch (error) {
      handleError(error);
    } finally {
      setFormLoading(false);
    }
  };

  const handleEdit = (data) => {
    setUpdateForm(data);
    setSelectedAddress(data);
    setShowAddressModal(true);
  };

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
      fetchAddresses(page);
    }
  };
  //! handle rows per page
  const handleRowsPerPageChange = (e) => {
    const newLimit = parseInt(e.target.value, 10);
    setRowsPerPage(newLimit);
    fetchAddresses(currentPage, newLimit);
  };

  return (
    <div className="mt-3 p-2 md:p-10 bg-gray-200">
      <div className="card">
        <span className="text-start font-bold ml-4 p-2 headingtext">
          Manage Address
        </span>
      </div>

      {/* <div className="card p-3">
        <div className="row d-flex align-items-end w-100">
          <div className="col-md-3">
            <label className="form-label font-bold">Status</label>
            <select
              className="form-select"
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
            >
              <option value="">Select Status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>

          <div className="col-md-3">
            <button
              className="btn btn-primary fw-bold btncolor mt-2"
              onClick={handleSearch}
            >
              SEARCH
            </button>
          </div>

          <div className="col-md-6 d-flex justify-content-end">
            <button className="btn btn-primary fw-bold btncolor mt-2" onClick={() => setShowAddAddressModal(true)}>
              Add New
            </button>
          </div>
        </div>
      </div> */}
      <div className="card p-3">
        <div className="row w-100">
          <div className="col-12 d-flex justify-content-end">
            <button
              className="btn btn-primary fw-bold btncolor"
              onClick={() => setShowAddAddressModal(true)}
            >
              Add New
            </button>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="table-container">
          <table className="table table-striped table-hover">
            <thead className="table-header table-primary">
              <tr>
                <th>Address</th>
                <th>City</th>
                <th>State</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {addressData.length > 0 ? (
                addressData.map((data) => (
                  <tr key={data.id}>
                    <td className="text-capitalize">{data.address}</td>
                    <td className="text-capitalize">{data.city}</td>
                    <td className="text-capitalize">{data.state}</td>
                    <td className="text-capitalize">{data.status}</td>
                    <td>
                      <button
                        onClick={() => handleEdit(data)}
                        className="btn btn-sm btn-primary"
                      >
                        <FaEdit />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center text-muted">
                    No data found for this criteria.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Modal show={showAddAddressModal} onHide={handleClose} size="md">
        <Modal.Header closeButton>
          <Modal.Title>Add Address</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">
                    Address <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="address"
                    value={addForm.address}
                    onChange={handleChange}
                  />
                  {errors.address && (
                    <div className="text-danger">{errors.address}</div>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">
                    City <span className="text-danger">*</span>
                  </Form.Label>
                  <Select
                    options={talkehrAddress}
                    value={
                      talkehrAddress.find(
                        (opt) => opt.value === addForm.azz_location_id
                      ) || null
                    }
                    onChange={(selected) => {
                      setAddForm({
                        ...addForm,
                        azz_location_id: selected ? selected.value : "",
                        city: selected ? selected.label : "",
                      });
                    }}
                    placeholder="Select or search "
                    isSearchable
                    isClearable
                  />

                  {errors.city && (
                    <div className="text-danger">{errors.city}</div>
                  )}
                </Form.Group>
              </div>

              {/* <div className="col-md-6 mb-3">
                <Form.Group>
                  <Form.Label className="fw-bold">
                    City <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="city"
                    value={addForm.city}
                    onChange={handleChange}
                  />
                  {errors.city && <div className="text-danger">{errors.city}</div>}
                </Form.Group>
              </div> */}
            </div>

            <div className="row">
              <div className="col-md-6 mb-3">
                <Form.Group>
                  <Form.Label className="fw-bold">
                    State <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="state"
                    value={addForm.state}
                    onChange={handleChange}
                  />
                  {errors.state && (
                    <div className="text-danger">{errors.state}</div>
                  )}
                </Form.Group>
              </div>

              {/* <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">
                    Status 
                  </Form.Label>
                  <Form.Select
                    name="status"
                    value={addForm.status}
                    onChange={handleChange}
                  >
                    <option value="">Select Status</option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </Form.Select>
                  {errors.status && <div className="text-danger">{errors.status}</div>}
                </Form.Group>
              </div> */}
              <div className="col-md-6 mb-3">
                <Form.Group>
                  <Form.Label className="fw-bold">Latitude</Form.Label>
                  <Form.Control
                    type="number"
                    name="latitude"
                    value={addForm.latitude}
                    onChange={handleChange}
                  />
                </Form.Group>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 mb-3">
                <Form.Group>
                  <Form.Label className="fw-bold">Longitude</Form.Label>
                  <Form.Control
                    type="number"
                    name="longitude"
                    value={addForm.longitude}
                    onChange={handleChange}
                  />
                </Form.Group>
              </div>
            </div>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>

          <Button
            variant="primary"
            onClick={handleAddAddress}
            disabled={loading}
          >
            {formLoading ? (
              <>
                <Spinner animation="border" size="sm" /> Saving...
              </>
            ) : (
              "Save Changes"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showAddressModal}
        onHide={() => {
          setShowAddressModal(false);
          setUpdateForm({
            address: "",
            city: "",
            state: "",
            status: "",
            latitude: "",
            longitude: "",
          });
          setErrors({});
        }}
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title> Update Address</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">
                    Address <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="address"
                    value={updateForm.address}
                    onChange={handleAddressChange}
                  />
                  {errors.address && (
                    <div className="text-danger">{errors.address}</div>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-6 mb-3">
                <Form.Group>
                  <Form.Label className="fw-bold">
                    City <span className="text-danger">*</span>
                  </Form.Label>
                  <Select
                    options={talkehrAddress}
                    value={
                      talkehrAddress.find(
                        (opt) => opt.value === updateForm.location_id
                      ) || null
                    }
                    onChange={(selected) => {
                      setUpdateForm({
                        ...updateForm,
                        location_id: selected ? selected.value : "",
                        city: selected ? selected.label : "",
                      });
                    }}
                    placeholder="Select or search "
                    isSearchable
                    isClearable
                  />
                  {errors.city && (
                    <div className="text-danger">{errors.city}</div>
                  )}
                </Form.Group>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 mb-3">
                <Form.Group>
                  <Form.Label className="fw-bold">
                    State <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="state"
                    value={updateForm.state}
                    onChange={handleAddressChange}
                  />
                  {errors.state && (
                    <div className="text-danger">{errors.state}</div>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <Form.Label className="fw-bold">
                    Status <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    name="status"
                    value={updateForm.status}
                    onChange={handleAddressChange}
                  >
                    <option value="">Select Status</option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </Form.Select>
                  {errors.status && (
                    <div className="text-danger">{errors.status}</div>
                  )}
                </Form.Group>
              </div>           
            </div>

            <div className="row">
               <div className="col-md-6 mb-3">
                <Form.Group>
                  <Form.Label className="fw-bold">Latitude</Form.Label>
                  <Form.Control
                    type="number"
                    name="latitude"
                    value={updateForm.latitude}
                    onChange={handleAddressChange}
                  />
                </Form.Group>
              </div>
              <div className="col-md-6 mb-3">
                <Form.Group>
                  <Form.Label className="fw-bold">Longitude</Form.Label>
                  <Form.Control
                    type="number"
                    name="longitude"
                    value={updateForm.longitude}
                    onChange={handleAddressChange}
                  />
                </Form.Group>
              </div>
            </div>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowAddressModal(false);
              setUpdateForm({
                address: "",
                city: "",
                state: "",
                status: "",
                latitude: "",
                longitude: "",
              });
              setErrors({});
            }}
          >
            Close
          </Button>

          <Button
            variant="primary"
            onClick={handleUpdateAddress}
            disabled={loading}
          >
            {formLoading ? (
              <>
                <Spinner animation="border" size="sm" /> Saving...
              </>
            ) : (
              "Save Changes"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
      {loading ? null : (
        <div className="pagination-controls">
          <PaginationControls
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            rowsPerPage={rowsPerPage}
            onLimitPerPage={handleRowsPerPageChange}
          />
        </div>
      )}
      {loading && <CommonSpinner />}
    </div>
  );
};

export default ManageAddress;
